<template>
  <div>
    <section class="stem">
      <p v-if="data.title"><span>练习标题：</span>{{ data.title }}</p>
      <p v-if="data.content"><span>练习要求：</span>{{ data.content }}</p>
    </section>
    <section class="submit_log" v-if="userInfo.type === 'TEACHER'">
      <p>已提交的练习</p>
      <el-table :data="data.details" stripe style="width: 100%">
        <el-table-column prop="studentName" align="center" label="姓名"> </el-table-column>
        <el-table-column prop="name" align="center" label="是否点评" sortable>
          <template slot-scope="scope">
            {{ scope.row.evaluateFlag === 0 ? "否" : "是" }}
          </template>
        </el-table-column>
        <el-table-column prop="address" align="center" label="点评星级" width="200">
          <template slot-scope="scope">
            <el-rate v-model="scope.row.evaluateStar" disabled></el-rate>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" align="center" label="时间"> </el-table-column>
        <el-table-column prop="address" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.evaluateFlag === 0"
              @click.native.prevent="commentChange(scope.row, scope.$index)"
              type="text"
              size="small"
            >
              点评
            </el-button>
            <el-button
              v-if="scope.row.evaluateFlag === 1"
              @click.native.prevent="seeCommentChange(scope.row)"
              type="text"
              size="small"
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <section class="submit_log" v-if="userInfo.type !== 'TEACHER'">
      <p>我的练习</p>
      <section v-if="!data.details.length">
        <div v-if="data.subType === 'TXT'">
          <cmpEditor :key="data.id" v-model="data.questionStem.content" height="300px"></cmpEditor>
        </div>
        <div v-else>
          <span v-if="data.subType === 'PROGRAMMING'" :style="{ marginBottom: '10px', display: 'block' }">
            去编程平台完成练习
            <el-button size="mini" type="primary" @click="goPracticeChange">去练习</el-button>
          </span>
          <cmpUploadFile @uploadFileChange="uploadFileChange"></cmpUploadFile>
          <el-table :data="data.userAnswer" stripe style="width: 100%" v-if="(data.userAnswer || []).length">
            <el-table-column prop="fileName" align="center" label="作品名称"> </el-table-column>
            <el-table-column prop="address" align="center" label="操作">
              <template slot-scope="scope">
                <el-button @click.native.prevent="deleteUserAnswerChange(scope.$index)" type="text" size="small">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </section>
      <section v-else>
        <el-table :data="data.details" stripe style="width: 100%">
          <el-table-column align="center" label="点评星级" width="200">
            <template slot-scope="scope">
              <el-rate v-model="scope.row.evaluateStar" disabled></el-rate>
            </template>
          </el-table-column>
          <el-table-column prop="evaluateText" align="center" label="点评内容"> </el-table-column>
          <el-table-column prop="address" align="center" label="操作" v-if="data.subType !== 'TXT'">
            <template slot-scope="scope">
              <!-- <el-button
                @click.native.prevent="TXTsubmitChange(scope.row)"
                type="text"
                size="small"
                v-if="scope.row.evaluateFlag === 0 && data.subType === 'TXT'"
              >
                编辑
              </el-button> -->
              <el-button
                @click.native.prevent="FILEsubmitChange(scope.row)"
                type="text"
                size="small"
                v-if="scope.row.evaluateFlag === 0 && data.subType !== 'TXT'"
              >
                编辑
              </el-button>
              <el-button
                @click="seeCommentChange(scope.row)"
                type="text"
                size="small"
                v-if="scope.row.evaluateFlag === 1"
              >
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </section>
    </section>
    <el-dialog
      class="comment_dialog"
      :title="commentMap.studentName + '-练习详情'"
      :visible.sync="commentFlag"
      width="50%"
    >
      <el-card>
        <div class="comment_stem">
          <p><span>练习标题：</span>{{ data.title }}</p>
          <p><span>练习要求：</span>{{ data.content }}</p>
        </div>
      </el-card>
      <el-card style="margin-top:30px">
        <section class="student_work" v-if="data.subType === 'TXT'">
          <div v-html="commentMap.studentAnswer"></div>
        </section>
        <section class="student_fileWork" v-if="data.subType !== 'TXT' && commentMap.studentAnswer">
          <!-- <p>提交的附件：<span>全部下载</span></p> -->
          <p v-for="(v, i) in JSON.parse(commentMap.studentAnswer)" :key="i">
            {{ v.fileName }}-{{ commentMap.studentName }}<span @click="downloadChange(v)">下载</span>
          </p>
          <!-- <p>海报1-张云夏<span>下载</span></p>
          <p>海报1-张云夏<span>下载</span></p>
          <p>海报1-张云夏<span>下载</span></p>
          <p>海报1-张云夏<span>下载</span></p> -->
        </section>
      </el-card>

      <el-card style="margin-top:30px">
        <div class="comment_option">
          <p>
            <span>星星点评：</span>
            <el-rate :disabled="commentMap.type === 'see'" v-model="commentMap.evaluateStar"></el-rate>
          </p>
          <p>
            <span>文字点评：</span
            ><el-input
              type="textarea"
              :disabled="commentMap.type === 'see'"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="学生很期待您的鼓励"
              v-model="commentMap.evaluateText"
            >
            </el-input>
          </p>
        </div>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="commentFlag = false">取 消</el-button>
        <el-button type="primary" @click="commentSubmitChange" v-if="commentMap.type !== 'see'">发布</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cmpEditor from "../../catalogue-editable/modules/cmp-editor.vue";
import cmpUploadFile from "./cmp-upload-file.vue";
import publicUrl from "@/assets/js/interface";
import { mapState } from "vuex";
// import toolsWeb from "@/assets/tools/tools-web.js";

export default {
  components: {
    cmpEditor,
    cmpUploadFile,
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    data: {
      handler(n) {
        if (typeof n.options === "string") n.options = JSON.parse(n.options || "");
        if (typeof n.questionStem === "string") n.questionStem = JSON.parse(n.questionStem || "");
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      commentMap: {
        type: "",
        evaluateText: "",
        evaluateStar: 0,
        studentAnswer: "",
        id: "",
      },
      commentFlag: false,
      tableData: [],
    };
  },

  methods: {
    goPracticeChange() {
      alert("等待提供跳转地址");
    },
    downloadChange(item) {
      // 创建form元素
      var temp_form = document.createElement("form");
      // 设置form属性
      temp_form.action = item.url;
      temp_form.target = "_blank";
      temp_form.method = "get";
      temp_form.style.display = "none";
      document.body.appendChild(temp_form);
      // 提交表单
      temp_form.submit();
    },
    commentSubmitChange() {
      if (!this.commentMap.evaluateStar || !this.commentMap.evaluateText) {
        this.$message.error("请点星并评价以后在发布");
        return false;
      }

      this.$ajaxJson
        .post(publicUrl.submitEvaluate, {
          ...this.commentMap,
        })
        .then((res) => {
          this.$ajaxCheck(res);
          this.$set(this.data.details[this.commentMap.index], "evaluateStar", this.commentMap.evaluateStar);
          this.$set(this.data.details[this.commentMap.index], "evaluateText", this.commentMap.evaluateText);
          this.$set(this.data.details[this.commentMap.index], "evaluateFlag", 1);
          this.$nextTick(() => {
            this.commentMap = {};
            this.commentFlag = false;
          });
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    TXTsubmitChange(item) {
      this.$set(this.data.questionStem, "content", item.studentAnswer);
    },
    FILEsubmitChange(item) {
      this.$set(this.data, "userAnswer", JSON.parse(item.studentAnswer));
      this.$set(this.data, "details", []);
    },
    // 删除用户上传答案数据
    deleteUserAnswerChange(index) {
      if (!this.data.userAnswer.length) return false;
      this.data.userAnswer.splice(index, 1);
    },
    // 上传用户附件
    uploadFileChange(file) {
      let arr = this.data.userAnswer || [];
      arr.push(file);
      this.$set(this.data, "userAnswer", arr);
    },
    // 查看点评
    seeCommentChange(item) {
      this.commentMap = {
        id: item.id,
        type: "see",
        evaluateText: item.evaluateText,
        evaluateStar: item.evaluateStar,
        studentAnswer: item.studentAnswer,
        studentName: item.studentName,
      };
      this.commentFlag = true;
    },
    // 老师点评
    commentChange(item, index) {
      this.commentMap = {
        type: "update",
        evaluateText: "",
        evaluateStar: 0,
        id: item.id,
        studentAnswer: item.studentAnswer,
        studentName: item.studentName,
        index: index,
      };
      this.commentFlag = true;
    },
  },
};
</script>

<style lang="less" scoped>
.stem {
  p {
    line-height: 25px;
    span {
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: #333333;
    }
  }
}

.submit_log {
  margin-top: 10px;
  p {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #19a4ff;
    line-height: 20px;
    padding: 14px 0;
  }
}

.comment_dialog {
  .title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #333333;
  }
  .student_work {
    max-height: 200px;
    overflow-y: auto;
  }

  .student_fileWork {
    p {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
      span {
        color: #19a4ff;
        cursor: pointer;
        margin-left: 20px;
        &:hover {
          opacity: 0.8;
        }
      }
    }
  }
  .comment_stem {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    p {
      margin-bottom: 5px;
      line-height: 25px;
      span {
        font-weight: bold;
      }
    }
  }
  .comment_option {
    p {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span {
        display: inline-block;
        width: 6em;
      }
    }
  }
}
</style>
